export const AD_COUNTDOWN = 'ASAdCountdown';
export const ADULT_SWIM_RETURN = 'ASReturnControl';
export const CAPTIONS_CONTROL = 'CaptionsButton';
export const SUBTITLES_CONTROL = 'SubtitlesButton';
export const CLOSE_BUTTON = 'ASCloseButton';
export const FULLSCREEN_TOGGLE = 'ASFullscreenToggle';
export const PLAY_TOGGLE = 'ASPlayToggle';
export const MUTE_TOGGLE = 'ASMuteToggle';
export const SHARE_CONTROL = 'ASShareControl';
export const SHARE_OVERLAY = 'ASShareOverlay';
export const VOLUME_CONTROL = 'ASVolumeControl';
export const VOLUME_SLIDER_WRAPPER = 'ASSliderWrapper';
export const VOLUME_SLIDER = 'ASVolumeSlider';
export const VOLUME_BAR = 'ASVolumeBar';


// WEBPACK FOOTER //
// ./src/ui/UIControlsNames.js